/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Notfound_Heading_No_RecordInputs */



/**
* | output |
* | --- |
* | "The Rift has no record of this" |
*
* @param {Error_Notfound_Heading_No_RecordInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_notfound_heading_no_record = /** @type {((inputs?: Error_Notfound_Heading_No_RecordInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Notfound_Heading_No_RecordInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Rift kennt das nicht")
	if (locale === "fr") return /** @type {LocalizedString} */ ("La Faille n'en a aucune trace")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("裂隙没有相关记录")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("裂隙沒有這件事的紀錄")
	if (locale === "ko") return /** @type {LocalizedString} */ ("균열에는 이런 기록이 없습니다")
	return /** @type {LocalizedString} */ ("The Rift has no record of this")
});